import styled from 'styled-components'

import { getToken } from '@helpscout/hsds-tokens/getToken'

import { generateVisuallyHiddenStyles } from 'hsds/utils/mixins'

import { NotyElementUI } from '../NotyElement/NotyElement.css'

export const NotyRendererUI = styled.div`
  position: fixed;
  top: 8px;
  left: 0;
  right: 0;
  display: flex;
  z-index: ${getToken('zindex.notification')};
  align-items: center;
  flex-direction: column;
  height: 0;

  ${NotyElementUI} {
    z-index: 20001;
    position: relative;
  }
`

export const NotyAnnouncementsUI = styled.div`
  ${generateVisuallyHiddenStyles()}
`
